export function formatMoney(sum: number): string {
  const splitter = ' ';
  let sumStr = String(sum);

  if (!sumStr) { return ''; }

  sumStr = sumStr.replace(/[^\d\.]/gi, '');
  sumStr = String(Math.ceil(parseInt(sumStr, 10) * 1));

  let pos = sumStr.length - 3;
  let res = '';

  while (pos > 0) {
      res = splitter + sumStr.substr(pos, 3) + res;
      pos -= 3;
  }
  res = sumStr.substr(0, pos + 3) + res;

  return res;
}

export default formatMoney;



// WEBPACK FOOTER //
// ./src/utils/format_money.ts